import GlobalStyles from "./styles/GlobalStyles";
import { ParallaxProvider } from 'react-scroll-parallax';
import { BrowserRouter } from "react-router-dom";
import RoutesContainer from "./RoutesContainer";
import { Helmet } from 'react-helmet-async';

function App() {
  return (
    <>
      <Helmet>
        <title>GREX</title>
        <meta name="title" content="GREX" />
        <meta name="description" content="GREX is The Easiest Way to Make Blockchain Games FUN for All Games." />
        <meta name="keywords" content="GREX, 지렉스, P2E게임, P2E 게임마켓, P2E 게임 플랫폼, 지렉스 게임즈, 위믹스, WEMIX, 블록체인 게임, 그립팬, GRIPFAN, 피그박스, PIGBOX" />
        <meta property="og:title" content="GREX" />
        <meta property="og:description" content="GREX is The Easiest Way to Make Blockchain Games FUN for All Games." />
        <meta property="og:keywords" content="GREX, 지렉스, P2E게임, P2E 게임마켓, P2E 게임 플랫폼, 지렉스 게임즈, 위믹스, WEMIX, 블록체인 게임, 그립팬, GRIPFAN, 피그박스, PIGBOX" />
      </Helmet>
      <ParallaxProvider>
        <BrowserRouter>
          <GlobalStyles />
          <RoutesContainer />
        </BrowserRouter>
      </ParallaxProvider>
    </>

  );
}

export default App;
